import * as ConfigCat from 'configcat-react'
import {useAuth} from '../stores/AuthStore'

export const useFeatureFlag = <T extends ConfigCat.SettingValue>(
  key: string,
  defaultValue: T,
): {
  value: ConfigCat.SettingTypeOf<T>
  loading: boolean
} => {
  const {client, person, identityEmail} = useAuth()

  let configCatUser

  if (client?.ID && person?.ID) {
    configCatUser = new ConfigCat.User(
      person.ID,
      person.email ?? undefined,
      '',
      {
        clientId: client.ID,
        clientName: client.name,
        application: 'Campanion Admin',
        // The ConfigCat `Email` field above is `person.email` — the
        // CAMP-SCOPED persons-service record for the currently selected
        // client. It is per-camp and frequently blank, so a targeting rule
        // written against it matches inconsistently for anyone active in more
        // than one camp (the same defect that moved useIsCampMinderEmployee
        // off person.email).
        //
        // `identityEmail` is the Auth0 LOGIN-IDENTITY email, constant across
        // camp switches, and is the reliable attribute to target an individual
        // user on. Added as a CUSTOM attribute rather than replacing the
        // `Email` field so no existing flag rule changes behavior — nothing
        // can already be targeting an attribute that did not exist.
        identityEmail: identityEmail ?? '',
      },
    )
  }

  return ConfigCat.useFeatureFlag(key, defaultValue, configCatUser)
}
